import React from 'react';
import { Box } from 'grommet';
import { colors } from '@theme/globals/colors';

enum BaseStatus {
  OCCUPIED = 'occupied',
  EMPTY = 'empty',
}

const BaseTracker: React.FC<{ runners: number[] }> = ({
  runners = [0, 0, 0, 0],
}) => {
  const baseColor = colors['black-alpha-20'] as string;
  const occupiedBaseColor = colors['black-alpha-80'] as string;

  return (
    <Box
      className="bases"
      margin={{ right: 'auto', left: 'auto', top: '0', bottom: 'xxsmall' }}
      height="auto"
      alignContent="center"
    >
      <svg
        width="30"
        height="16"
        viewBox="0 0 30 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Vector">
          <path
            id="first"
            className={`bbsb-base ${runners.includes(1) ? BaseStatus.OCCUPIED : BaseStatus.EMPTY}`}
            d="M23.8236 15.8148L29.5692 11.9479C30.1436 11.5613 30.1436 10.7687 29.5692 10.382L23.8236 6.51513C23.4567 6.26824 22.9598 6.26824 22.5929 6.51513L16.8474 10.382C16.2729 10.7686 16.2729 11.5613 16.8474 11.9479L22.5929 15.8148C22.9598 16.0617 23.4567 16.0617 23.8236 15.8148Z"
            fill={runners.includes(1) ? occupiedBaseColor : baseColor}
          />
          <path
            id="second"
            className={`bbsb-base ${runners.includes(2) ? BaseStatus.OCCUPIED : BaseStatus.EMPTY}`}
            d="M15.6153 9.48487L21.3609 5.61796C21.9354 5.23135 21.9354 4.43868 21.3609 4.05207L15.6153 0.185165C15.2485 -0.0617214 14.7515 -0.0617219 14.3847 0.185165L8.63909 4.05207C8.06465 4.43868 8.06465 5.23135 8.63909 5.61796L14.3847 9.48487C14.7515 9.73176 15.2485 9.73176 15.6153 9.48487Z"
            fill={runners.includes(2) ? occupiedBaseColor : baseColor}
          />
          <path
            id="third"
            className={`bbsb-base ${runners.includes(3) ? BaseStatus.OCCUPIED : BaseStatus.EMPTY}`}
            d="M7.40706 15.8148L13.1526 11.9479C13.7271 11.5613 13.7271 10.7687 13.1526 10.382L7.40706 6.51513C7.04022 6.26824 6.54326 6.26824 6.17642 6.51513L0.430835 10.382C-0.143611 10.7686 -0.143612 11.5613 0.430834 11.9479L6.17642 15.8148C6.54326 16.0617 7.04022 16.0617 7.40706 15.8148Z"
            fill={runners.includes(3) ? occupiedBaseColor : baseColor}
          />
        </g>
      </svg>
    </Box>
  );
};

export default BaseTracker;
